class AudioService {
  callingInterval = null;

  constructor () {
    if (window.AudioContext || window.webkitAudioContext) {
      this.context = new (window.AudioContext || window.webkitAudioContext)();
      this.iOsHack();
    }
  }

  timeEnded () {
    const { osc, wet, filter } = this.createSound(false);

    osc.type = 'square';
    osc.frequency.setValueAtTime(100, this.context.currentTime);
    filter.frequency.setValueAtTime(5000, this.context.currentTime);

    osc.start();
    wet.gain.setTargetAtTime(0.5, this.context.currentTime, 0.01);
    wet.gain.setTargetAtTime(0, this.context.currentTime + 0.1, 0.01);
    wet.gain.setTargetAtTime(0.5, this.context.currentTime + 0.15, 0.01);
    wet.gain.setTargetAtTime(0, this.context.currentTime + 0.25, 0.01);
    setTimeout(() => {
      osc.stop();
    }, 700);
  }

  startCalling () {
    clearInterval(this.callingInterval);
    this.callSound();
    this.callingInterval = setInterval(() => this.callSound(), 2500);
  }

  stopCalling () {
    clearInterval(this.callingInterval);
  }

  callSound () {
    const { osc, wet } = this.createSound();

    osc.start();
    wet.gain.setTargetAtTime(0.6, this.context.currentTime, 0.1);
    osc.frequency.setTargetAtTime(1002, this.context.currentTime, 0.3);
    wet.gain.setValueAtTime(0, this.context.currentTime + 0.3);
    wet.gain.setTargetAtTime(0.6, this.context.currentTime + 0.7, 0.3);
    osc.frequency.setTargetAtTime(1002, this.context.currentTime + 0.7, 0.3);
    wet.gain.setValueAtTime(0, this.context.currentTime + 1.1);
    setTimeout(() => {
      osc.stop();
    }, 1100);
  }

  createSound (delay = true) {
    const osc = this.createOsc();
    const wet = this.context.createGain();

    wet.gain.setValueAtTime(0, this.context.currentTime);
    wet.gain.setTargetAtTime(1, this.context.currentTime, 0.3);
    osc.connect(wet);

    const filter = this.createFilter(wet);
    wet.connect(filter);

    if (delay) { this.createAndConnectDelay(filter); }

    filter.connect(this.context.destination);

    return { osc, wet, filter };
  }

  createOsc () {
    const osc = this.context.createOscillator();
    osc.type = 'sawtooth';
    osc.frequency.setValueAtTime(1000, this.context.currentTime);
    return osc;
  }

  createFilter () {
    const filter = this.context.createBiquadFilter();
    filter.type = 'lowpass';
    filter.frequency.setValueAtTime(800, this.context.currentTime);
    filter.Q.setValueAtTime(10, this.context.currentTime);
    return filter;
  }

  createAndConnectDelay (audioPipe) {
    for (let i = 0; i < 3; i++) {
      const volume = this.context.createGain();
      volume.gain.setValueAtTime(0.5 / (Math.pow((i + 1), 2)), this.context.currentTime);
      const delay = this.context.createDelay(1);
      delay.delayTime.setValueAtTime(0.25 * (i + 1), this.context.currentTime);
      audioPipe.connect(volume);
      volume.connect(delay);
      delay.connect(this.context.destination);
    }
  }

  iOsHack () {
    window.addEventListener('touchstart', () => {
      var buffer = this.context.createBuffer(1, 1, 22050);
      var source = this.context.createBufferSource();
      source.buffer = buffer;

      source.connect(this.context.destination);

      source.start(0);
    }, false);
  }
}

export default new AudioService();
